module.exports = __webpack_public_path__ + "img/11.2afea439.jpg";